import { AlertTriangle } from 'lucide-react'

import { cn } from 'components/UI/cn'
import type { Campaign } from 'models/campaign'

interface MissingContactsBannerProps {
  campaign: Campaign
  className?: string
}

/**
 * Surface targets that have zero contacts so the user can fix or remove them
 * before launch. Shows nothing when every target has at least one contact.
 */
export function MissingContactsBanner({
  campaign,
  className,
}: MissingContactsBannerProps) {
  const total = campaign.contact_company_count
  const withContacts = campaign.companies_with_contacts
  const missing = Math.max(0, total - withContacts)

  if (total === 0 || missing === 0) return null

  return (
    <div
      role="status"
      className={cn(
        'flex items-start gap-3 rounded-lg border border-warning-border bg-warning-bg px-4 py-3 text-sm text-warning-strong',
        className
      )}
    >
      <AlertTriangle className="mt-0.5 size-4 shrink-0 text-warning" />
      <div className="flex-1">
        <p className="font-medium">
          {missing} of {total} {total === 1 ? 'target' : 'targets'}{' '}
          {missing === 1 ? 'has' : 'have'} no contacts yet
        </p>
        <p className="mt-0.5 text-xs text-fg-secondary">
          Filter the table by Contacts = 0 to review, then request contacts or
          remove the company before launch.
        </p>
      </div>
    </div>
  )
}
